"use strict";

var _regeneratorRuntime = require("/Users/mmach/git/2_WAX/frontend/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/mmach/git/2_WAX/frontend/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/mmach/git/2_WAX/frontend/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var eosjs_1 = require("eosjs");

var WaxEventSource_1 = require("./WaxEventSource");

var WaxJS =
/*#__PURE__*/
function () {
  function WaxJS(rcpEndpoint, userAccount, pubKeys) {
    var waxSigningURL = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "https://all-access.wax.io";
    var waxAutoSigningURL = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "https://api-idm.wax.io/v1/accounts/auto-accept/";

    _classCallCheck(this, WaxJS);

    this.waxSigningURL = waxSigningURL;
    this.waxAutoSigningURL = waxAutoSigningURL;
    this.waxEventSource = new WaxEventSource_1.WaxEventSource(waxSigningURL);
    this.rpc = new eosjs_1.JsonRpc(rcpEndpoint);

    if (userAccount && Array.isArray(pubKeys)) {
      var data = {
        userAccount: userAccount,
        pubKeys: pubKeys,
        verified: true
      };
      this.receiveLogin({
        data: data
      });
    }
  }

  _createClass(WaxJS, [{
    key: "login",
    value: function login() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.canAutoLogin()) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", this.loginViaEndpoint().catch(function () {
                  return (// Attempt to recover by logging in via the window method
                    _this.loginViaWindow()
                  );
                }));

              case 2:
                return _context.abrupt("return", this.loginViaWindow());

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "loginViaWindow",
    value: function loginViaWindow() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var confirmationWindow;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.waxEventSource.openEventSource(this.waxSigningURL + "/cloud-wallet/login/");

              case 2:
                confirmationWindow = _context2.sent;
                return _context2.abrupt("return", this.waxEventSource.onceEvent(confirmationWindow, this.waxSigningURL, this.receiveLogin.bind(this)));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "loginViaEndpoint",
    value: function loginViaEndpoint() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var response, data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return fetch(this.waxAutoSigningURL + "login", {
                  credentials: "include",
                  method: "get"
                });

              case 2:
                response = _context3.sent;

                if (response.ok) {
                  _context3.next = 5;
                  break;
                }

                throw new Error("Login Endpoint Error ".concat(response.status, " ").concat(response.statusText));

              case 5:
                _context3.next = 7;
                return response.json();

              case 7:
                data = _context3.sent;

                if (!(data.processed && data.processed.except)) {
                  _context3.next = 10;
                  break;
                }

                throw new Error(data);

              case 10:
                return _context3.abrupt("return", this.receiveLogin({
                  data: data
                }));

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "canAutoLogin",
    value: function canAutoLogin() {
      // only allow autologin with chrome
      return localStorage.getItem("autoLogin") === "true" && this.isChrome();
    }
  }, {
    key: "receiveLogin",
    value: function receiveLogin(event) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var _this2 = this;

        var _event$data, verified, userAccount, pubKeys, whitelistedContracts, autoLogin, signer, transact, url;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _event$data = event.data, verified = _event$data.verified, userAccount = _event$data.userAccount, pubKeys = _event$data.pubKeys, whitelistedContracts = _event$data.whitelistedContracts, autoLogin = _event$data.autoLogin;

                if (verified) {
                  _context6.next = 3;
                  break;
                }

                throw new Error("User declined to share their user account");

              case 3:
                if (!(userAccount == null || pubKeys == null)) {
                  _context6.next = 5;
                  break;
                }

                throw new Error("User does not have a blockchain account");

              case 5:
                localStorage.setItem("autoLogin", autoLogin);
                this.whitelistedContracts = whitelistedContracts || [];
                this.userAccount = userAccount;
                this.pubKeys = pubKeys;
                signer = {
                  getAvailableKeys: function getAvailableKeys() {
                    return _this2.pubKeys;
                  },
                  sign: function sign(data) {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee4() {
                      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              _context4.t0 = data.serializedTransaction;
                              _context4.next = 3;
                              return this.signing(data.serializedTransaction);

                            case 3:
                              _context4.t1 = _context4.sent;
                              return _context4.abrupt("return", {
                                serializedTransaction: _context4.t0,
                                signatures: _context4.t1
                              });

                            case 5:
                            case "end":
                              return _context4.stop();
                          }
                        }
                      }, _callee4, this);
                    }));
                  }
                }; // @ts-ignore

                this.api = new eosjs_1.Api({
                  rpc: this.rpc,
                  signatureProvider: signer
                });
                transact = this.api.transact.bind(this.api);
                url = this.waxSigningURL + "/cloud-wallet/signing/"; // We monkeypatch the transact method to overcome timeouts
                // firing the pop-up which some browsers enforce, such as Safari.
                // By pre-creating the pop-up window we will interact with,
                // we ensure that it is not going to be rejected due to a delayed
                // pop up that would otherwise occur post transaction creation

                this.api.transact = function (transaction, namedParams) {
                  return __awaiter(_this2, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee5() {
                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.next = 2;
                            return this.canAutoSign(transaction);

                          case 2:
                            if (_context5.sent) {
                              _context5.next = 6;
                              break;
                            }

                            _context5.next = 5;
                            return window.open(url, "WaxPopup", "height=800,width=600");

                          case 5:
                            this.signingWindow = _context5.sent;

                          case 6:
                            _context5.next = 8;
                            return transact(transaction, namedParams);

                          case 8:
                            return _context5.abrupt("return", _context5.sent);

                          case 9:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5, this);
                  }));
                };

                return _context6.abrupt("return", this.userAccount);

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "canAutoSign",
    value: function canAutoSign(transaction) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var _this3 = this;

        var deserializedTransaction;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!transaction.actions) {
                  _context7.next = 4;
                  break;
                }

                _context7.t0 = transaction;
                _context7.next = 7;
                break;

              case 4:
                _context7.next = 6;
                return this.api.deserializeTransactionWithActions(transaction);

              case 6:
                _context7.t0 = _context7.sent;

              case 7:
                deserializedTransaction = _context7.t0;
                return _context7.abrupt("return", !deserializedTransaction.actions.find(function (action) {
                  return !_this3.isWhitelisted(action);
                }));

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "isWhitelisted",
    value: function isWhitelisted(action) {
      return !!this.whitelistedContracts.find(function (w) {
        if (w.contract === action.account) {
          if (action.account === "eosio.token" && action.name === "transfer") {
            return w.recipients.includes(action.data.to);
          }

          return true;
        }

        return false;
      });
    }
  }, {
    key: "signing",
    value: function signing(transaction) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.canAutoSign(transaction);

              case 2:
                if (!_context8.sent) {
                  _context8.next = 4;
                  break;
                }

                return _context8.abrupt("return", this.signViaEndpoint(transaction).catch(function () {
                  return (// Attempt to recover by signing via the window method
                    _this4.signViaWindow(undefined, transaction)
                  );
                }));

              case 4:
                return _context8.abrupt("return", this.signViaWindow(this.signingWindow, transaction));

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "signViaEndpoint",
    value: function signViaEndpoint(transaction) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var response, data;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return fetch(this.waxAutoSigningURL + "signing", {
                  body: JSON.stringify({
                    transaction: Object.values(transaction)
                  }),
                  credentials: "include",
                  headers: {
                    "Content-Type": "application/json"
                  },
                  method: "POST"
                });

              case 3:
                response = _context9.sent;

                if (response.ok) {
                  _context9.next = 6;
                  break;
                }

                throw new Error("Signing Endpoint Error ".concat(response.status, " ").concat(response.statusText));

              case 6:
                _context9.next = 8;
                return response.json();

              case 8:
                data = _context9.sent;

                if (!(data.processed && data.processed.except)) {
                  _context9.next = 11;
                  break;
                }

                throw new Error(data);

              case 11:
                return _context9.abrupt("return", this.receiveSignatures({
                  data: data
                }));

              case 14:
                _context9.prev = 14;
                _context9.t0 = _context9["catch"](0);
                // clear the whitelist to make sure we don't repeatedly attempt blocked actions
                this.whitelistedContracts = [];
                throw _context9.t0;

              case 18:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 14]]);
      }));
    }
  }, {
    key: "signViaWindow",
    value: function signViaWindow(window, transaction) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        var confirmationWindow;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.waxEventSource.openEventSource(this.waxSigningURL + "/cloud-wallet/signing/", {
                  type: "TRANSACTION",
                  transaction: transaction
                }, window);

              case 2:
                confirmationWindow = _context10.sent;
                return _context10.abrupt("return", this.waxEventSource.onceEvent(confirmationWindow, this.waxSigningURL, this.receiveSignatures.bind(this)));

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "receiveSignatures",
    value: function receiveSignatures(event) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11() {
        var _event$data2, verified, signatures, whitelistedContracts;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!(event.data.type === "TX_SIGNED")) {
                  _context11.next = 6;
                  break;
                }

                _event$data2 = event.data, verified = _event$data2.verified, signatures = _event$data2.signatures, whitelistedContracts = _event$data2.whitelistedContracts;

                if (!(!verified || signatures == null)) {
                  _context11.next = 4;
                  break;
                }

                throw new Error("User declined to sign the transaction");

              case 4:
                this.whitelistedContracts = whitelistedContracts || [];
                return _context11.abrupt("return", signatures);

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "isChrome",
    value: function isChrome() {
      return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    }
  }]);

  return WaxJS;
}();

exports.WaxJS = WaxJS;